<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import type { Schemas } from '@shopware/api-client/api-types';

const props = defineProps<{
    element: Schemas['CmsSlot'];
}>();

const elementConfig = useCmsElementConfig(props.element);
const { getCmsLink } = useFormatCmsLink();

const headline = elementConfig.getConfigValue('heading');
const description = elementConfig.getConfigValue('description');
const buttonText = elementConfig.getConfigValue('button');
const link = await getCmsLink(elementConfig.getConfigValue('url'));
</script>

<template>
    <div
        class="flex flex-col justify-center bg-neutral-250 md:absolute md:inset-0 md:left-4 md:z-10 md:h-max md:max-w-md-lg md:self-center md:p-4"
    >
        
<FormKitLazyProvider config-file="true">
<h2 class="text-3xl font-extrabold md:text-5xl">
            {{ headline }}
        </h2>
        <p class="mb-4 mt-2 md:mb-6 md:text-2xl">
            {{ description }}
        </p>

        <LocaleLink
            v-if="buttonText && link"
            :to="link"
            class="max-w-max"
        >
            <FormKit
                type="button"
                :label="buttonText"
                :classes="{
                    input: 'font-bold text-lg text-white !bg-neutral-800 max-w-max',
                }"
            />
        </LocaleLink>
</FormKitLazyProvider>

    </div>
</template>
